import _defineProperty from "@babel/runtime/helpers/defineProperty";
import ApiClient from "./api";
import FeedClient from "./clients/feed";
import Preferences from "./clients/preferences";
var DEFAULT_HOST = "https://api.knock.app";

class Knock {
  constructor(apiKey) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.apiKey = apiKey;

    _defineProperty(this, "host", void 0);

    _defineProperty(this, "apiClient", null);

    _defineProperty(this, "userId", void 0);

    _defineProperty(this, "userToken", void 0);

    _defineProperty(this, "feeds", new FeedClient(this));

    _defineProperty(this, "preferences", new Preferences(this));

    this.host = options.host || DEFAULT_HOST; // Fail loudly if we're using the wrong API key

    if (this.apiKey && this.apiKey.startsWith("sk_")) {
      throw new Error("[Knock] You are using your secret API key on the client. Please use the public key.");
    }
  }

  client() {
    if (!this.userId) {
      console.warn("[Knock] You must call authenticate(userId, userToken) first before trying to make a request.\n        Typically you'll see this message when you're creating a feed instance before having called\n        authenticate with a user Id and token. That means we won't know who to issue the request\n        to Knock on behalf of.\n        ");
    } // Initiate a new API client if we don't have one yet


    if (!this.apiClient) {
      this.apiClient = new ApiClient({
        apiKey: this.apiKey,
        host: this.host,
        userToken: this.userToken
      });
    }

    return this.apiClient;
  }
  /*
    Authenticates the current user. In non-sandbox environments
    the userToken must be specified.
  */


  authenticate(userId, userToken) {
    this.userId = userId;
    this.userToken = userToken;
    return;
  }
  /*
    Returns whether or this Knock instance is authenticated. Passing `true` will check the presence
    of the userToken as well.
  */


  isAuthenticated() {
    var checkUserToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return checkUserToken ? this.userId && this.userToken : this.userId;
  } // Used to teardown any connected instances


  teardown() {
    if (!this.apiClient) return;
    this.apiClient.socket.disconnect();
  }

}

export default Knock;
//# sourceMappingURL=knock.js.map